/** @format */

import { request } from 'src/utils'

// 策略列表
export const getPrometheusAlertPolicyList = async (params?) => {
  const result = await request('/monitor/?Action=ListPrometheusAlertPolicies&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}
// 删除策略
export const deletePrometheusAlertPolicy = async (params?) => {
  const result = await request('/monitor/?Action=DeletePrometheusAlertPolicy&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 删除规则
export const deletePrometheusAlertRule = async (params?) => {
  const result = await request('/monitor/?Action=DeletePrometheusAlertRule&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 修改规则状态
export const updatePrometheusAlertRuleState = async (params?) => {
  const result = await request('/monitor/?Action=UpdateAlertRuleState&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 修改策略下规则状态
export const updatePrometheusAlertPolicyRuleState = async (params?) => {
  const result = await request(
    '/monitor/?Action=UpdatePrometheusAlertPolicyState&Version=2025-01-01',
    {
      data: params || {},
      method: 'POST'
    }
  )
  return result
}

// 创建策略
export const createPrometheusAlertPolicy = async (params?) => {
  const result = await request('/monitor/?Action=CreatePrometheusAlertPolicy&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 更新策略
export const updatePrometheusAlertPolicy = async (params?) => {
  const result = await request('/monitor/?Action=UpdatePrometheusAlertPolicy&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 模板列表
export const getPrometheusAlertTemplateList = async (params?) => {
  const result = await request('/monitor/?Action=ListPrometheusAlertTemplates&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 模板详情
export const getPrometheusAlertTemplate = async (params?) => {
  const result = await request('/monitor/?Action=GetPrometheusAlertTemplate&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 创建模板
export const createPrometheusAlertTemplate = async (params?) => {
  const result = await request(
    '/monitor/?Action=CreatePrometheusAlertPolicyTemplate&Version=2025-01-01',
    {
      data: params || {},
      method: 'POST'
    }
  )
  return result
}

// 更新模板
export const updatePrometheusAlertTemplate = async (params?) => {
  const result = await request(
    '/monitor/?Action=UpdatePrometheusAlertPolicyTemplate&Version=2025-01-01',
    {
      data: params || {},
      method: 'POST'
    }
  )
  return result
}

// 删除模板
export const deletePrometheusAlertTemplate = async (params?) => {
  const result = await request(
    '/monitor/?Action=DeletePrometheusAlertPolicyTemplate&Version=2025-01-01',
    {
      data: params || {},
      method: 'DELETE'
    }
  )
  return result
}

// YAML校验
export const validateAlertRule = async (params?) => {
  const result = await request('/monitor/?Action=ValidateAlertRule&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data
}

// 告警中列表
export const getPrometheusAlerting = async (params?) => {
  const result = await request('/monitor/?Action=ListPrometheusAlerts&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 通知列表
export const getPrometheusAlertNotific = async (params?) => {
  const result = await request(
    '/monitor/?Action=ListPrometheusAlertNotificationRecords&Version=2025-01-01',
    {
      data: params || {},
      method: 'GET'
    }
  )
  return result?.data
}

// 告警降噪 - 抑制规则
// 告警降噪 - 抑制规则 - 规则列表
export const getPrometheusAlertInhibitions = async (params?) => {
  const result = await request('/monitor/?Action=ListAlertInhibitionRules&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 告警降噪 - 抑制规则 - 删除规则
export const deletePrometheusAlertInhibition = async (params?) => {
  const result = await request('/monitor/?Action=DeleteAlertInhibitionRule&Version=2025-01-01', {
    data: params || {},
    method: 'DELETE'
  })
  return result
}

// 告警降噪 - 抑制规则 - 新建规则
export const createPrometheusAlertInhibition = async (params?) => {
  const result = await request('/monitor/?Action=CreateAlertInhibitionRule&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 告警降噪 - 抑制规则 - 更新规则
export const updatePrometheusAlertInhibition = async (params?) => {
  const result = await request('/monitor/?Action=UpdateAlertInhibitionRule&Version=2025-01-01', {
    data: params || {},
    method: 'PUT'
  })
  console.log('result', result)
  return result
}

// 告警降噪 - 静默规则
// 告警降噪 - 静默规则 - 规则列表
export const getPrometheusAlertSilences = async (params?) => {
  const result = await request('/monitor/?Action=ListAlertSilenceRules&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data
}
// 告警降噪 - 静默规则 - 删除规则
export const deletePrometheusAlertSilence = async (params?) => {
  const result = await request('/monitor/?Action=DeleteAlertSilenceRule&Version=2025-01-01', {
    data: params || {},
    method: 'DELETE'
  })
  return result
}

// 告警降噪 - 静默规则 - 创建规则
export const createPrometheusAlertSilence = async (params?) => {
  const result = await request('/monitor/?Action=CreateAlertSilenceRule&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 告警降噪 - 静默规则 - 更新规则
export const updatePrometheusAlertSilence = async (params?) => {
  const result = await request('/monitor/?Action=UpdateAlertSilenceRule&Version=2025-01-01', {
    data: params || {},
    method: 'PUT'
  })
  return result
}

// PromQL数据预览
export const previewPrometheusAlertRule = async (params?) => {
  const result = await request('/monitor/?Action=GetPrometheusPreviewData&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 获取指标labels
export const getMetricLabels = async (params?) => {
  const result = await request('/monitor/?Action=ListMetricLabels&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}
